import MabinsoModel from '../../app/models/MabinsoModel';
import Globals from '../../../utils/Globals';

class ActionModel extends MabinsoModel {
    backend = true;
    urlRoot = Globals.baseUrl + 'actions/action';
}

export default ActionModel;
